import styled from 'styled-components';
import { usePatternContext } from '../../../../context/PatternContext';
import {
  AppraisalPointData,
  MarketPriceEstimationData,
  NumberOfFailedBidData,
  OldAgeData,
  SalesDaysData,
} from '../data';

interface PatternItemProps {
  tab: string;
}
const PatternItem = ({ tab }: PatternItemProps) => {
  const { pattern1, pattern2, pattern3, setSelectedTab } = usePatternContext();
  const ChangeValueToLabel = (value: string, data: any) => {
    const newValue = data.find((item: any) => item.value === value)?.label;
    return newValue ?? '';
  };

  const renderingData = () => {
    if (tab === '핵심 알고리즘') {
      return (
        <>
          <TitleWrapper>
            <TitleBox>
              <img src="assets/images/icon/check-on.svg" />
              <div>핵심 알고리즘</div>
            </TitleBox>
            <div>
              <span
                onClick={() => {
                  setSelectedTab('핵심 알고리즘');
                }}
              >
                변경
              </span>
            </div>
          </TitleWrapper>
          <SelectedArea>
            <SelectedBox>
              {pattern2.saleProfit !== 'A' && (
                <SelectedItemContent>
                  <span>
                    {pattern2.saleProfit === 'Y'
                      ? `차익有(낙찰가<매각가)`
                      : `차익無(낙찰가>매각가)`}
                  </span>
                </SelectedItemContent>
              )}
              {pattern2.hiddenValue !== 'A' && (
                <SelectedItemContent>
                  <span>
                    {pattern2.hiddenValue === 'L'
                      ? `저평가 (시세>감정가)`
                      : `고평가 (시세<감정가)`}
                  </span>
                </SelectedItemContent>
              )}
              {pattern2.takeProfit !== '' && (
                <SelectedItemContent>
                  <span>
                    {pattern2.takeProfit === 'Y'
                      ? '부대비용 포함'
                      : '부대비용 미포함'}
                  </span>
                </SelectedItemContent>
              )}
              {pattern2.marketPrice && pattern2.marketPrice !== 'A' && (
                <SelectedItemContent>
                  <span>
                    {ChangeValueToLabel(
                      pattern2.marketPrice,
                      MarketPriceEstimationData,
                    )}
                  </span>
                </SelectedItemContent>
              )}
              {pattern2.appraisalPoint && pattern2.appraisalPoint !== '' && (
                <SelectedItemContent>
                  <span>
                    {'감정시점> '}
                    {ChangeValueToLabel(
                      pattern2.appraisalPoint,
                      AppraisalPointData,
                    )}
                  </span>
                </SelectedItemContent>
              )}
              {pattern2.bidCount && pattern2.bidCount !== '' && (
                <SelectedItemContent>
                  <span>
                    {'유찰횟수> '}
                    {ChangeValueToLabel(
                      pattern2.bidCount,
                      NumberOfFailedBidData,
                    )}
                  </span>
                </SelectedItemContent>
              )}
              {pattern2.oldAge && pattern2.oldAge !== '' && (
                <SelectedItemContent>
                  <span>
                    {'노후년도> '}
                    {ChangeValueToLabel(pattern2.oldAge, OldAgeData)}
                  </span>
                </SelectedItemContent>
              )}
              {pattern2.saleDays && pattern2.saleDays !== '' && (
                <SelectedItemContent>
                  <span>
                    {'매각일수> '}
                    {ChangeValueToLabel(pattern2.saleDays, SalesDaysData)}
                  </span>
                </SelectedItemContent>
              )}
              {pattern2.investmentAmount !== '평균 실투자금' &&
                pattern2.enteredAmount !== '' && (
                  <SelectedItemContent>
                    <span>낙찰가의 {pattern2.enteredAmount} %</span>
                  </SelectedItemContent>
                )}
            </SelectedBox>
          </SelectedArea>
        </>
      );
    } else if (tab === '특수 알고리즘') {
      return (
        <>
          <TitleWrapper>
            <TitleBox>
              <img src="assets/images/icon/check-on.svg" />
              <div>특수 알고리즘</div>
            </TitleBox>
            <div>
              <span
                onClick={() => {
                  setSelectedTab('특수 알고리즘');
                }}
              >
                변경
              </span>
            </div>
          </TitleWrapper>
          <SelectedBox>
            {Object.entries(pattern3).map(([key, value]) => (
              <>
                {value === 'Y' && (
                  <SelectedItemContent key={key}>
                    <span>{`${handleChangeText(key)}> 선택`}</span>{' '}
                  </SelectedItemContent>
                )}
              </>
            ))}
          </SelectedBox>
        </>
      );
    } else {
      return (
        <>
          <TitleWrapper>
            <TitleBox>
              <img src="assets/images/icon/check-on.svg" />
              <div>{tab}</div>
            </TitleBox>
            <div>
              <span
                onClick={() => {
                  setSelectedTab('분석 기준');
                }}
              >
                변경
              </span>
            </div>
          </TitleWrapper>
          <SelectedArea>
            <SelectedBox>
              {pattern1.region.sido !== '' && (
                <SelectedItemContent>
                  <span>
                    {pattern1.region.sido}
                    {pattern1.region.sigungu === ''
                      ? ''
                      : `>${pattern1.region.sigungu}`}
                    {pattern1.region.emd === ''
                      ? ''
                      : `>${pattern1.region.emd}`}
                  </span>
                </SelectedItemContent>
              )}
              {pattern1.itemStatus !== '' && (
                <SelectedItemContent>
                  <span>{pattern1.itemStatus}</span>
                </SelectedItemContent>
              )}
              {pattern1.analysisPeriod.start !== '' && (
                <SelectedItemContent>
                  <span>
                    {pattern1.analysisPeriod.start}~
                    {pattern1.analysisPeriod.end}
                  </span>
                </SelectedItemContent>
              )}
              {pattern1.useArea.length > 0 && (
                <>
                  {pattern1.useArea.map((status, i) => (
                    <SelectedItemContent key={i}>
                      <span>{status}</span>
                    </SelectedItemContent>
                  ))}
                </>
              )}
            </SelectedBox>
          </SelectedArea>
        </>
      );
    }
  };
  return <Inner>{renderingData()}</Inner>;
};
export default PatternItem;

const Inner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  color: #222222;
  font-size: 16px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 23.2px;
  word-wrap: break-word;
`;
const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
  span {
    color: #616161;
    font-size: 14px;
  }
`;

const SelectedArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #e5e8ea;
`;
const SelectedBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 6px;
  flex-wrap: wrap;
  row-gap: 6px;
`;
const SelectedItemContent = styled.span`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: #616161;
  background-color: rgba(112, 115, 124, 0.05);
  border-radius: 9999px;
  padding: 4px 8px;
  border: 1px #e1e2e4 solid;
`;
const handleChangeText = (text: string) => {
  if (text === 'hugCondition') {
    return 'HUG인수 조건변경';
  }
  if (text === 'tenantsOpposition') {
    return '임차인 대항력';
  }
  if (text === 'wageBond') {
    return '임금채권';
  }
  if (text === 'resale') {
    return '재매각';
  }
  if (text === 'violatingBuilding') {
    return '위반건축물';
  }
  if (text === 'statutoryLandRights') {
    return '법정지상권';
  }
  if (text === 'graveSiteRights') {
    return '분묘기지권';
  }
  if (text === 'lien') {
    return '유치권';
  }
};
